import styled from 'styled-components'

export const Head = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Loaded = styled.div`
  display: flex;
  color: #FF9300;
`
export const Approved = styled.div`
  display: flex;
  color: #6CC04A;
`
export const Rejected = styled.div`
  display: flex;
  color: #FF6C6C;
`



// WEBPACK FOOTER //
// ./src/pages/ValidateBrand/styles.js